import { hideLoading, showLoading } from '@design/objects/button/twig/assets/loading'

export default function (form: HTMLFormElement): void {
  const buttonEl = form.querySelector<HTMLButtonElement>('[type="submit"]')

  if (!buttonEl) {
    return
  }

  form.addEventListener('submit', function () {
    showLoading(buttonEl)
  })

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      hideLoading(buttonEl)
    }
  })
}
